<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Frederic Martini has always loved dogs and science fiction. He has published in the fields of human anatomy and physiology, vertebrate evolution, marine science, and history. <em>Hounded</em> reflects his experiences with dogs, high-tech science, and science fiction.</p><br/>
<p style="text-indent:0em;">Dr. Martini’s hobbies include blue-water sailing, scuba, submersible diving, and trying to keep his two young labradoodle/border collie crosses from destroying the furniture.</p><br/>
<p style="text-indent:0em;">More information on the author can be found at www.fredericmartini.com.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?2f608f6e